import DOMPurify from 'dompurify';

/**
 * Sanitize HTML string before rendering with dangerouslySetInnerHTML.
 * Removes <script>, event handlers (on*), javascript: URLs, and other XSS vectors.
 */
export function sanitizeHtml(html: string): string {
  // In browser environment, DOMPurify needs a DOM.
  // jsdom is not available here, so we rely on DOMPurify's built-in browser sanitization.
  // If running in non-browser context (SSR), return as-is (should not happen in this app).
  if (typeof window === 'undefined') {
    return html;
  }

  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'a', 'blockquote', 'code', 'pre', 'hr',
      'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'div', 'span', 'section', 'article', 'header', 'footer',
      'sub', 'sup', 'del', 'ins', 'mark', 'small', 'abbr',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'target', 'rel', 'class', 'id'],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['rel'],
    ALLOW_ARIA_ATTR: true,
    FORBID_TAGS: ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit'],
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
  });
}
